<template>
    <l-list
        :columns="columns"
        :dataSource="dataSource"
        :showHeader="showHeader"
        height="notset"
    >
    </l-list>
</template>
<script>
export default {
    name: 'l-list-table',
    props: {
        columns:{
            type:Array,
            default:()=>[]
        },
        dataSource:{
            type: Array,
            default: () => []
        },
        showHeader:{
            type:Boolean,
            default: false
        },
        code:String,
        paramFiled:[String,Number]
    },
    data() {
        return {
            //dataSource:this.dataSource
        }
    },
    mounted(){
        this.viewTableData()
    },
    watch:{
        paramFiled(){
            this.viewTableData()
        }
    },
    methods: {
        async viewTableData(){
            if(this.paramFiled && this.code){
                const apiDbsource = window.$api.data.dbsource
                const data = await this.$awaitWraper(apiDbsource.getDataListByParamter(this.code,this.paramFiled))
                this.dataSource =  data || []
            }
            else{
                //this.dataSource = []
            }
        }
    }
}
</script>